// The sticky stack under the dashboard header bar, top to bottom:
//
//   dashboard header bar   top 0        h-24  = 6rem
//   tabs strip (optional)  top 6rem     h-12  = 3rem   → `--tabs-offset`
//   PageHeader             6rem + offset       min-h 8rem
//   MainFilterBar          14rem + offset      h-12 = 3rem
//   top pagination bar     17rem + offset      (PaginationBar / PaginationBarClient)
//
// `--tabs-offset` is 0 unless the page sets STICKY_TABS_OFFSET_CLASS
// (see MainStickyTabsBar). Every table page has a filter bar, so the table's
// sticky top is one fixed number. Tailwind picks these class strings up from
// this file; keep them literal (no template strings).
export const STICKY_TOP_PAGE_HEADER_CLASS =
  "top-[calc(6rem_+_var(--tabs-offset,0px))]";
export const STICKY_TOP_FILTER_BAR_CLASS =
  "top-[calc(14rem_+_var(--tabs-offset,0px))]";
export const STICKY_TOP_TABLE_CLASS =
  "top-[calc(17rem_+_var(--tabs-offset,0px))]";
